import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PagedList } from '@rma/dashboard/generic/domain/to-be-sorted';
import { Environment, RMA_DEFAULT_HTTP_OPTIONS } from '@rma/dashboard/generic/util/environment';
import { appendToRmaMarketorApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';
import { UserNotificationEventType, UserNotificationModel } from './domain';

@Injectable({
  providedIn: 'root',
})
export class NotificationBellApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly marketorApiUrl = inject(appendToRmaMarketorApiUrl);
  private readonly environment = inject(Environment);

  public getNotifications(filter?: Partial<UserNotificationFilter>): Observable<PagedList<UserNotificationModel>> {
    const endpoint = `usernotification/${this.environment.tenant}`;
    const url = this.marketorApiUrl(endpoint);
    const params = filter ? new HttpParams({ fromObject: filter }) : undefined;
    return this.httpClient.get<PagedList<UserNotificationModel>>(url, {
      params,
    });
  }

  public postNotificationEvent(userNotificationCode: string, userNotificationEventType: UserNotificationEventType): Observable<void> {
    const endpoint = `usernotification/event/${this.environment.tenant}/${userNotificationCode}/${userNotificationEventType}`;
    const url = this.marketorApiUrl(endpoint);

    return this.httpClient.post<void>(url, RMA_DEFAULT_HTTP_OPTIONS);
  }

  public markAllAsRead(): Observable<void> {
    const endpoint = `usernotification/${this.environment.tenant}/markAllAsRead`;
    const url = this.marketorApiUrl(endpoint);

    return this.httpClient.post<void>(url, RMA_DEFAULT_HTTP_OPTIONS);
  }
}

export interface UserNotificationFilter {
  take: number;
  skip: number;

  onlyNew: boolean;
  includeExpired: boolean;
  includeDismissed: boolean;
}
